import { breakpointMd } from '@farol-ds/tokens'
import { ExperimentsContext } from '@jusbrasil-web/docview/core'
import { useViewportSize } from '@jusbrasil-web/shared-hooks'
import { SD_DOCVIEW_CHATS_EXPERIMENT_NAME } from '@jusbrasil-web/shared-seus-direitos'
import { useContext, useMemo } from 'react'

export interface UseSdDocviewChatsTrackingInput {
  isExperimentArticle: boolean
}

export interface SdDocviewChatsTrackingMetadata {
  experiment: string | null
  variant: string | null
}

export function useSdDocviewChatsTracking({
  isExperimentArticle,
}: UseSdDocviewChatsTrackingInput): SdDocviewChatsTrackingMetadata {
  const experimentsContext = useContext(ExperimentsContext)
  const { width } = useViewportSize()

  const experiment = experimentsContext?.getExperiment(SD_DOCVIEW_CHATS_EXPERIMENT_NAME)
  const participating = experiment?.participating ?? false
  const alternative = experiment?.alternative ?? null

  return useMemo(() => {
    if (!isExperimentArticle) {
      return { experiment: null, variant: null }
    }

    const isInExperimentViewport = width > 0 && width < breakpointMd
    if (!isInExperimentViewport) {
      return { experiment: null, variant: null }
    }

    if (!participating) {
      return { experiment: null, variant: null }
    }

    return {
      experiment: SD_DOCVIEW_CHATS_EXPERIMENT_NAME,
      variant: alternative,
    }
  }, [isExperimentArticle, width, participating, alternative])
}
